import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension, CustomFieldExtensionSchema } from '@backstage/plugin-scaffolder-react';
import {
    Sev2TagCombobox,
    Sev2TagComboboxSchema,
} from './Sev2TagCombobox';

export const Sev2TagComboboxFieldExtension = scaffolderPlugin.provide(
    createScaffolderFieldExtension({
        name: 'Sev2TagCombobox',
        component: Sev2TagCombobox,
        schema: Sev2TagComboboxSchema as CustomFieldExtensionSchema,
    }),
);
